<template>
  <div class="mt-3 pb-3 card shadow-sm">
    <p class="card-header float-left">試合の流れ</p>
    <line-chart :chartData="chartData" :optionData="optionData" :height="350"/>
  </div>
</template>

<script>
import LineChart from '@/components/atoms/LineChart';
import func from '@/lib/func';

function judge(info) {
  if (info.p1 >= 11 || info.p2 >= 11) {
    if ((info.p1 - info.p2) ** 2 >= 4) {
      return true;
    }
  }
  return false;
}
// p1のシミュレーター用の得点率を計算
function getRecentRate(p1, p2) {
  return 0.45 + ((p1 / (p1 + p2)) * 0.1);
}

function simulator(sim, rate, matchCnt) {
  const times = 100;
  const ret = [];
  let info = {};
  for (let i = 0; i < times; i++) {
    // 初期状態を設定
    info = Object.assign({}, sim);
    // 試合終了までループ
    while (info.s1 < matchCnt && info.s2 < matchCnt) {
      const rand = Math.random();
      // 得点判定
      if (rand < rate) {
        info.p1 += 1;
      } else {
        info.p2 += 1;
      }
      // セット終了判定
      if (judge(info)) {
        if (info.p1 >= info.p2) {
          info.s1 += 1;
        } else {
          info.s2 += 1;
        }
        info.p1 = 0;
        info.p2 = 0;
      }
    }
    // 勝者判定.vue
    if (info.s1 >= info.s2) {
      ret.push(1);
    } else {
      ret.push(0);
    }
  }
  return func.sumArr(ret) / ret.length;
}

function calcRate(points, matchCnt) {
  const info = {
    p1: 0,
    p2: 0,
    s1: 0,
    s2: 0,
  };
  const ret1 = [];
  const ret2 = [];
  const p1r = [];
  const p2r = [];
  let simResult = 0;
  for (let i = 0; i < points.length; i++) {
    info.p1 += points[i];
    info.p2 += points[i] ^ 1;
    if (judge(info)) {
      if (info.p1 > info.p2) {
        info.s1 += 1;
      } else {
        info.s2 += 1;
      }
      info.p1 = 0;
      info.p2 = 0;
    }
    p1r.push(points[i]);
    p2r.push(points[i] ^ 1);
    if (p1r.length >= 8) {
      p1r.shift();
      p2r.shift();
    }
    // シミュレートする
    simResult = simulator(info, getRecentRate(func.sumArr(p1r) / p1r.length,
      func.sumArr(p2r) / p2r.length), matchCnt);
    ret1.push(func.round2(simResult));
    ret2.push(func.round2(1 - simResult));
  }
  return { 1: ret1, 2: ret2 };
}

export default {
  name: 'match-flow',
  components: {
    LineChart,
  },
  props: ['points', 'gameInfo', 'matchCnt'],
  computed: {
    chartData() {
      let match = this.matchCnt;
      if (match === 0) {
        match = this.gameInfo.matchCnt;
      } else {
        match = 1;
      }
      const result = calcRate(this.points, match);
      const labelArray = new Array(result[1].length);
      for (let i = 0; i < labelArray.length; i++) {
        labelArray[i] = i + 1;
      }
      return {
        labels: labelArray,
        datasets: [
          {
            label: this.gameInfo.player1Name,
            borderColor: '#82B8D7',
            backgroundColor: 'rgba(130,184,215,0.5)',
            data: result[1],
          },
          {
            label: this.gameInfo.player2Name,
            borderColor: '#83D7BD',
            backgroundColor: 'rgba(131,215,189,0.5)',
            data: result[2],
          },
        ],
      };
    },
    optionData() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          point: {
            radius: 0,
          },
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 1,
              stepSize: 0.5,
            },
            stacked: true,
          }],
        },
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/MatchFlow.vue